import axios from 'axios';
import { createAuthenticationInterceptor, AuthType } from '@dtvgo/axios-interceptor-auth';
import { createClientHeadersInterceptor } from '@dtvgo/axios-interceptor-client-headers';
import { createErrorInterceptor, Source } from '@dtvgo/error';
import { createThinkAnalyticsParamsInterceptor } from './interceptors/thinkAnalyticsParams.js';
import { createLanguageInterceptor } from './interceptors/language.js';

function createAxiosInstance({
  host,
  getAccessTokenData,
  clientType,
  language,
  errorFactory,
  isConnected,
  timeout,
  authInterceptor,
  ...clientHeadersOptions
}) {
  const backendAxiosInstance = axios.create({
    adapter: ["fetch", "xhr"],
    baseURL: host,
    responseType: "json",
    headers: {
      "Content-Type": "application/json"
    },
    timeout
  });
  async function getSessionTokenForAuthInterceptor() {
    const accessTokenData = await getAccessTokenData();
    return accessTokenData?.idToken;
  }
  const authenticationInterceptor = createAuthenticationInterceptor({
    type: AuthType.SESSION_TOKEN,
    options: {
      sessionToken: getSessionTokenForAuthInterceptor
    }
  });
  const clientHeadersInterceptor = createClientHeadersInterceptor(clientHeadersOptions);
  const thinkAnalyticsParamsInterceptor = createThinkAnalyticsParamsInterceptor({ clientType });
  const languageInterceptor = createLanguageInterceptor({ language });
  let errorInterceptor;
  if (errorFactory) {
    errorInterceptor = createErrorInterceptor(errorFactory, {
      source: Source.MIDDLEWARE,
      getExternCode: (response) => response.data.code,
      getResponseMessage: (response) => {
        const data = response.data;
        return [data?.code, data?.details].filter(Boolean).join("|");
      },
      isConnected
    });
  }
  if (errorInterceptor)
    backendAxiosInstance.interceptors.request.use(void 0, errorInterceptor);
  backendAxiosInstance.interceptors.response.use(void 0, authInterceptor);
  backendAxiosInstance.interceptors.request.use(authenticationInterceptor);
  backendAxiosInstance.interceptors.request.use(thinkAnalyticsParamsInterceptor);
  backendAxiosInstance.interceptors.request.use(clientHeadersInterceptor);
  backendAxiosInstance.interceptors.request.use(languageInterceptor);
  if (errorInterceptor)
    backendAxiosInstance.interceptors.response.use(void 0, errorInterceptor);
  return backendAxiosInstance;
}

export { createAxiosInstance as default };
//# sourceMappingURL=createAxiosInstance.js.map
